import axios from 'axios'

const state = () => ({
  orders: [],
})

const getters = {
  getOrders: (state) => state.orders,
}

const actions = {
  async getOrders({ rootState, commit }) {
    const response = await axios.get(rootState.api + '/orders', {
      headers: {
        Authorization: 'Bearer ' + rootState.apiToken,
      },
    })

    commit('setOrders', response.data)
  },
}

const mutations = {
  setOrders(state, payload) {
    state.orders = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
